import { Immutable } from "immer";
import React from "react";
import { RichText } from "tsi-common-react/src/components/RichText/index";
import { TempurLoveBreadcrumbs } from "tsi-common-react/src/components/TempurLoveBreadcrumbs/index";
import { UGCApiGrid } from "tsi-common-react/src/components/UGCApiGrid/index";

import { templates } from "@reactivated";

// The social-gallery body is composed inside the live
// TempurLoveSocialPageDocumentTemplate, which passes down this subset of its
// own props; derive the shape from it so the two stay in sync.
type IProps = Immutable<
    Pick<
        templates.TempurLoveSocialPageDocumentTemplate,
        "page_info" | "love_root_info" | "initial_ugc_data" | "initial_next_url"
    >
>;

export const TempurLoveSocialPage = (props: IProps): React.JSX.Element => {
    const breadcrumbTitle = props.love_root_info.title;
    const breadcrumbUrl = props.love_root_info.url;

    return (
        <>
            <TempurLoveBreadcrumbs
                className="al-tlovesocial-breadcrumbs"
                items={[
                    { title: breadcrumbTitle, url: breadcrumbUrl || "/" },
                    { title: props.page_info.title, isCurrentPage: true },
                ]}
                useCappedWidth={true}
            />

            <div className="l-full-width">
                <div className="l-capped-width">
                    {props.page_info.description && (
                        <RichText html={props.page_info.description} />
                    )}
                    <article className="social-gallery al-tlovesocial-ugcgrid">
                        <UGCApiGrid
                            pageSize={20}
                            initialGridData={props.initial_ugc_data}
                            initialNextUrl={props.initial_next_url}
                        />
                    </article>
                </div>
            </div>
        </>
    );
};
